import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "The best $5 I have ever spent",
  "description": "",
  "published": "2011-12-13T00:00:00.000Z",
  "redirect_from": ["/blog/the-best-5-i-have-ever-spent/swizec/3172"],
  "categories": "Beacon Theatre (New York City), BitTorrent, Corporation, Digital rights management, DRM, Louis CK, Uncategorized, video",
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p><img parentName="p" {...{
        "src": "https://swizec.com/blog/wp-content/uploads/2011/12/300px-Louis_CK_Kuwait_crop3.jpg",
        "alt": "English: Comedian Louis C.K. performs for serv...",
        "title": "English: Comedian Louis C.K. performs for serv..."
      }}></img></p>
    <p>{`A few days ago Louis C.K. did something truly outstanding - he released `}<a parentName="p" {...{
        "href": "https://buy.louisck.net/"
      }}>{`Louis CK Live at the Bacon Theater`}</a>{`.`}</p>
    <p>{`It's a self-produced, self-published, self-everything hour of laughter inducing madness. That's right, you `}<em parentName="p">{`will`}</em>{` laugh. `}<em parentName="p">{`Out loud. `}{`_`}{`No, not just "lol". I mean `}{`_`}{`laugh`}</em>{`.`}</p>
    <p>{`He also put up what is probably the best anti-pirating plea I have read in a while; of course it only works if you aren't a big corporation and have no intention of suing me for damages up to `}<a parentName="p" {...{
        "href": "http://en.wikipedia.org/wiki/Recording_Industry_Association_of_America#Selection_of_defendants"
      }}>{`\\`}{`\\`}{`\\`}{`\\$150k every time I pirate a 5minute song`}</a>{`.`}</p>
    <blockquote>
      <p parentName="blockquote"><strong parentName="p">{`To those who might wish to "torrent" this video:`}</strong>{` look, I don't really get the whole "torrent" thing. I don't know enough about it to judge either way. But I'd just like you to consider this: I made this video extremely easy to use against well-informed advice. I was told that it would be easier to torrent the way I made it, but I chose to do it this way anyway, because I want it to be easy for people to watch and enjoy this video in any way they want without "corporate" restrictions.`}</p>
      <p parentName="blockquote">{`Please bear in mind that I am not a company or a corporation. I'm just some guy. I paid for the production and posting of this video with my own money. I would like to be able to post more material to the fans in this way, which makes it cheaper for the buyer and more pleasant for me. So, please help me keep this being a good idea. I can't stop you from `}<a parentName="p" {...{
          "href": "http://en.wikipedia.org/wiki/BitTorrent_%28protocol%29",
          "title": "BitTorrent (protocol)"
        }}>{`torrenting`}</a>{`; all I can do is politely ask you to pay your five little dollars, enjoy the video, and let other people find it in the same way.`}</p>
      <p parentName="blockquote">{`Sincerely, Louis C.K.`}</p>
    </blockquote>
    <p>{`Certainly the best five bucks I have ever spent ... hell, you pay almost as much for a good tea at Starbucks and that doesn't leave nearly as lasting an impression. I'd love to tell you what was so special about it, but this is standup comedy, if I try to tell you it will just come out pathetic and we'll both feel kind of awkward about it.`}</p>
    <p>{`If for whatever odd reason you have no idea who this Louis C.K. person is, and shame on you if you don't, here's a helpful video.`}</p>
    <lite-youtube {...{
      "videoid": "FzHzlMneaeQ",
      "videostartat": "0"
    }}></lite-youtube>
    <h6 {...{
      "id": "related-articles"
    }}>{`Related articles`}</h6>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://www.gearslutz.com/board/piracy-discussions/676654-louis-ck-piracy.html"
        }}>{`Louis CK & Piracy`}</a>{` (gearslutz.com)`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://www.digitaltrends.com/movies/do-not-torrent-louis-c-k-s-live-at-the-beacon-theater/"
        }}>{`Do not torrent Louis C.K.'s 'Live at the Beacon Theater'`}</a>{` (digitaltrends.com)`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://techfleece.com/2011/12/11/louis-c-k-releases-his-latest-work-via-direct-download-and-drm-free/"
        }}>{`Louis C.K Releases His Latest Work Via Direct Download And DRM Free`}</a>{` (techfleece.com)`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://gigaom.com/video/louis-ck-pirate-bay/"
        }}>{`Louis C.K. can't stop the pirates`}</a>{` (gigaom.com)`}</li>
    </ul>
    <p><a parentName="p" {...{
        "href": "http://www.zemanta.com/",
        "title": "Enhanced by Zemanta"
      }}><img parentName="a" {...{
          "src": "https://img.zemanta.com/zemified_e.png?x-id=b476eb30-e512-4f3d-91d2-a569b7bc53ef",
          "alt": "Enhanced by Zemanta"
        }}></img></a></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      